export default {
  MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_STATE_MANAGER:
    Symbol.for('MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_STATE_MANAGER'),
  MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_SUBSCRIPTION:
    Symbol.for('MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_SUBSCRIPTION'),
  GET_MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_QUERY:
    Symbol.for('GET_MY_INVESTMENT_ALLIANZ_ON_BOARDING_STATUS_QUERY'),
};
